import React, { useEffect, useState } from 'react';
import { Box, Button, LoadingOverlay, Select, Text } from '@mantine/core';
import { DriveInfoPanelsEnum } from '@/types/enums/modules';
import { IFilialsInfoCommon } from '@/entities/admin-app/filials';
import { useTranslation } from 'react-i18next';
import { useStyles } from '@/containers/pages/filials/edit/styles';
import { storageConfigurationApiArea } from '@/services/api/storageConfigurationApiArea';
import { IStorageConfiguration } from '@/services/api/storageConfigurationApiArea/types';
import { IconChevronDown } from '@tabler/icons-react';
import { useForm } from '@mantine/form';
import { IFilialStorageConfiguration } from '@/entities/admin-app/filials/types';
import { useUpdateFilialSettingsMutation } from '@/entities/admin-app/filials/api';
import { notifications } from '@mantine/notifications';
import { SettingsEnum } from '@/containers/pages/filials/utils';

interface IFilialStorageProps {
  filial: IFilialsInfoCommon;
}

export const FilialStorage = ({ filial }: IFilialStorageProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const [storages, setStorages] = useState<IStorageConfiguration[]>([]);
  const [isLoadingStorages, setIsLoadingStorages] = useState(false);
  const [updateFilialSettings, { isLoading: isSaving }] = useUpdateFilialSettingsMutation();
  console.log('filial', filial);
  console.log('filial.Settings?.StorageId?.toString()', filial.Settings?.StorageId?.toString());
  const storageForm = useForm<IFilialStorageConfiguration>({
    initialValues: {
      Id: filial.Settings?.StorageId?.toString() ?? null
    },
    validateInputOnChange: true
  });

  useEffect(() => {
    const fetchStorages = async () => {
      try {
        setIsLoadingStorages(true);
        const data = await storageConfigurationApiArea().GetStorageConfigurations();
        setStorages(data);
      } catch (error) {
        console.error('Error fetching storages:', error);
      } finally {
        setIsLoadingStorages(false);
      }
    };

    fetchStorages();
  }, []);

  useEffect(() => {
    const newId = filial.Settings?.StorageId?.toString() ?? null;

    // Обновляем форму только если значения действительно изменились
    if (storageForm.values.Id !== newId) {
      const storageData = {
        Id: newId
      };
      storageForm.setValues(storageData);
      storageForm.resetDirty(storageData);
    }
  }, [filial.Storage?.Id]);

  const storageOptions = storages
    .filter((s) => s.IsEnabled)
    .map((storage) => ({
      value: storage.Id.toString(),
      label: storage.Name
    }));
  console.log('storageOptions', storageOptions);
  const handleStorageChange = (value: string | null) => {
    if (value === null) {
      return;
    }
    const selectedStorage = storages.find((s) => s.Id.toString() === value);
    if (selectedStorage) {
      storageForm.setFieldValue('Id', selectedStorage.Id.toString());
    }
  };

  const handleSubmit = async () => {
    try {
      await updateFilialSettings({
        id: filial.Id,
        type: SettingsEnum.StorageConfigurationSettings,
        StorageId: storageForm.values.Id
      }).unwrap();
      storageForm.resetDirty();
      notifications.show({
        message: t('filials.diskSpace.storageUpdated'),
        color: 'green'
      });
    } catch (error) {
      console.error('Error saving storage:', error);
      notifications.show({
        message: t('filials.diskSpace.storageUpdateError'),
        color: 'red'
      });
    }
  };

  const isDisabled = !storageForm.isDirty() || isSaving || isLoadingStorages;
  console.log('storageForm.values.Id?.toString()', storageForm.values.Id?.toString());
  return (
    <Box className={classes.section} data-section={DriveInfoPanelsEnum.filialQuota}>
      <Text className={classes.title}>{t('profile.storageBinding')}</Text>
      <Box className={classes.container} data-section={DriveInfoPanelsEnum.filialQuota}>
        <Text size="sm" c="dimmed" mb="md">
          {t('profile.storageBindingDescription')}
        </Text>
        <Select
          label={t('profile.selectStorage')}
          placeholder={
            storageForm.values.Id === null ? t('profile.noStorage') : t('profile.selectStorage')
          }
          data={storageOptions}
          value={storageForm.values.Id?.toString() || null}
          onChange={handleStorageChange}
          rightSection={<IconChevronDown size="1rem" color="#98A2B3" />}
          disabled={isLoadingStorages}
          clearable={false}
          comboboxProps={{ zIndex: 10000 }}
          mb="md"
          style={{ maxWidth: '400px' }}
        />
        <Button
          onClick={handleSubmit}
          size="sm"
          radius={8}
          disabled={isDisabled}
          style={{ padding: '0 20px' }}
        >
          {t('profile.save')}
        </Button>
      </Box>
      <LoadingOverlay visible={isSaving || isLoadingStorages} />
    </Box>
  );
};
